export default
[
  {
    "name":"add1",
    "tag":"add1"
  },
  {
    "name":"add2",
    "tag":"add2"
  },
  {
    "name":"add3",
    "tag":"add3"
  },
  {
    "name":"add4",
    "tag":"add4"
  },
  {
    "name":"alert",
    "tag":"alert"
  },
  {
    "name":"application",
    "tag":"application"
  },
  {
    "name":"arrow-down1",
    "tag":"arrow-down1"
  },
  {
    "name":"arrow-down2",
    "tag":"arrow-down2"
  },
  {
    "name":"arrow-download",
    "tag":"arrow-download"
  },
  {
    "name":"arrow-left1",
    "tag":"arrow-left1"
  },
  {
    "name":"arrow-left2",
    "tag":"arrow-left2"
  },
  {
    "name":"arrow-right1",
    "tag":"arrow-right1"
  },
  {
    "name":"arrow-right2",
    "tag":"arrow-right2"
  },
  {
    "name":"arrow-up1",
    "tag":"arrow-up1"
  },
  {
    "name":"arrow-up2",
    "tag":"arrow-up2"
  },
  {
    "name":"brush",
    "tag":"brush"
  },
  {
    "name":"chart1",
    "tag":"chart1"
  },
  {
    "name":"chart2",
    "tag":"chart2"
  },
  {
    "name":"chart3",
    "tag":"chart3"
  },
  {
    "name":"chart3",
    "tag":"chart3"
  },
  {
    "name":"chart4",
    "tag":"chart4"
  },
  {
    "name":"chart4",
    "tag":"chart4"
  },
  {
    "name":"clear",
    "tag":"clear"
  },
  {
    "name":"comments",
    "tag":"comments"
  },
  {
    "name":"copy",
    "tag":"copy"
  },
  {
    "name":"copy20",
    "tag":"copy20"
  },
  {
    "name":"cut-office",
    "tag":"cut-office"
  },
  {
    "name":"cut",
    "tag":"cut"
  },
  {
    "name":"data2",
    "tag":"data2"
  },
  {
    "name":"date1",
    "tag":"date1"
  },
  {
    "name":"date2",
    "tag":"date2"
  },
  {
    "name":"del1",
    "tag":"del1"
  },
  {
    "name":"del10",
    "tag":"del10"
  },
  {
    "name":"del2",
    "tag":"del2"
  },
  {
    "name":"delete1",
    "tag":"delete1"
  },
  {
    "name":"delete10",
    "tag":"delete10"
  },
  {
    "name":"delete2",
    "tag":"delete2"
  },
  {
    "name":"delete3",
    "tag":"delete3"
  },
  {
    "name":"delete4",
    "tag":"delete4"
  },
  {
    "name":"delete5",
    "tag":"delete5"
  },
  {
    "name":"delete6",
    "tag":"delete6"
  },
  {
    "name":"delete8",
    "tag":"delete8"
  },
  {
    "name":"directory",
    "tag":"directory"
  },
  {
    "name":"edit1",
    "tag":"edit1"
  },
  {
    "name":"edit10",
    "tag":"edit10"
  },
  {
    "name":"edit2",
    "tag":"edit2"
  },
  {
    "name":"edit3",
    "tag":"edit3"
  },
  {
    "name":"edit4",
    "tag":"edit4"
  },
  {
    "name":"edit8",
    "tag":"edit8"
  },
  {
    "name":"email-open",
    "tag":"email-open"
  },
  {
    "name":"email1",
    "tag":"email1"
  },
  {
    "name":"email2",
    "tag":"email2"
  },
  {
    "name":"email3",
    "tag":"email3"
  },
  {
    "name":"excel",
    "tag":"excel"
  },
  {
    "name":"file-data",
    "tag":"file-data"
  },
  {
    "name":"file-open",
    "tag":"file-open"
  },
  {
    "name":"file-open2",
    "tag":"file-open2"
  },
  {
    "name":"file-shut",
    "tag":"file-shut"
  },
  {
    "name":"file",
    "tag":"file"
  },
  {
    "name":"file1",
    "tag":"file1"
  },
  {
    "name":"file2",
    "tag":"file2"
  },
  {
    "name":"filesave",
    "tag":"filesave"
  },
  {
    "name":"folder-files",
    "tag":"folder-files"
  },
  {
    "name":"folder-open",
    "tag":"folder-open"
  },
  {
    "name":"folder-open",
    "tag":"folder-open"
  },
  {
    "name":"folder",
    "tag":"folder"
  },
  {
    "name":"folder1",
    "tag":"folder1"
  },
  {
    "name":"forward",
    "tag":"forward"
  },
  {
    "name":"graph",
    "tag":"graph"
  },
  {
    "name":"help1",
    "tag":"help1"
  },
  {
    "name":"help2",
    "tag":"help2"
  },
  {
    "name":"help3",
    "tag":"help3"
  },
  {
    "name":"homepage1",
    "tag":"homepage1"
  },
  {
    "name":"homepage2",
    "tag":"homepage2"
  },
  {
    "name":"homepage3",
    "tag":"homepage3"
  },
  {
    "name":"homepage4",
    "tag":"homepage4"
  },
  {
    "name":"info1",
    "tag":"info1"
  },
  {
    "name":"info2",
    "tag":"info2"
  },
  {
    "name":"list",
    "tag":"list"
  },
  {
    "name":"list2",
    "tag":"list2"
  },
  {
    "name":"list3",
    "tag":"list3"
  },
  {
    "name":"login",
    "tag":"login"
  },
  {
    "name":"message",
    "tag":"message"
  },
  {
    "name":"ok1",
    "tag":"ok1"
  },
  {
    "name":"ok10",
    "tag":"ok10"
  },
  {
    "name":"ok2",
    "tag":"ok2"
  },
  {
    "name":"ok2",
    "tag":"ok2"
  },
  {
    "name":"ok20",
    "tag":"ok20"
  },
  {
    "name":"ok3",
    "tag":"ok3"
  },
  {
    "name":"ok30",
    "tag":"ok30"
  },
  {
    "name":"ok4",
    "tag":"ok4"
  },
  {
    "name":"password",
    "tag":"password"
  },
  {
    "name":"paste",
    "tag":"paste"
  },
  {
    "name":"print1",
    "tag":"print1"
  },
  {
    "name":"print2",
    "tag":"print2"
  },
  {
    "name":"redo",
    "tag":"redo"
  },
  {
    "name":"reload",
    "tag":"reload"
  },
  {
    "name":"rss",
    "tag":"rss"
  },
  {
    "name":"save",
    "tag":"save"
  },
  {
    "name":"save3",
    "tag":"save3"
  },
  {
    "name":"search",
    "tag":"search"
  },
  {
    "name":"search1",
    "tag":"search1"
  },
  {
    "name":"search2",
    "tag":"search2"
  },
  {
    "name":"send",
    "tag":"send"
  },
  {
    "name":"status-disable",
    "tag":"status-disable"
  },
  {
    "name":"status-green",
    "tag":"status-green"
  },
  {
    "name":"status-grey",
    "tag":"status-grey"
  },
  {
    "name":"status-red",
    "tag":"status-red"
  },
  {
    "name":"status-yellow",
    "tag":"status-yellow"
  },
  {
    "name":"task",
    "tag":"task"
  },
  {
    "name":"time",
    "tag":"time"
  },
  {
    "name":"time2",
    "tag":"time2"
  },
  {
    "name":"tip",
    "tag":"tip"
  },
  {
    "name":"undo",
    "tag":"undo"
  },
  {
    "name":"undo1",
    "tag":"undo1"
  },
  {
    "name":"undo2",
    "tag":"undo2"
  },
  {
    "name":"undo3",
    "tag":"undo3"
  },
  {
    "name":"unlock",
    "tag":"unlock"
  },
  {
    "name":"user1",
    "tag":"user1"
  },
  {
    "name":"user10",
    "tag":"user10"
  },
  {
    "name":"user2",
    "tag":"user2"
  },
  {
    "name":"users",
    "tag":"users"
  }
]

